import { addWarning } from "@wayflyer/blackbox-fe";

/**
 * Retrieves __APP_VERSION__ (commit SHA) and __APP_NAME__ (app identifier)
 * that are injected at build time via Vite's define configuration.
 * Used to identify app version in Datadog and others.
 */
export function getAppVersionContext(): {
  version: string | null;
  appName: string | null;
} {
  try {
    const version = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : null;
    const appName = typeof __APP_NAME__ !== "undefined" ? __APP_NAME__ : null;

    return { version, appName };
  } catch (error) {
    addWarning("Failed to get app version context:", { error });
    return { version: null, appName: null };
  }
}

//  Generates HTTP headers for app version and name to be included in API requests
export function getAppVersionHeaders(): Record<string, string> {
  const { version, appName } = getAppVersionContext();
  const headers: Record<string, string> = {};

  if (version) {
    headers["x-frontend-version"] = version;
  }

  if (appName) {
    headers["x-frontend-app"] = appName;
  }

  return headers;
}
